import { IUser } from "utils/Interface/components";
import { parseCookies, setCookie, destroyCookie } from "nookies";
import jwt_decode from "jwt-decode";
import LogRocket from "logrocket";

const maxAge = 30 * 24 * 60 * 60;

const setJwt = (response: any) => {
  if (response.token)
    setCookie(null, "jwt", response.token, {
      maxAge,
      path: "/",
    });
  if (response.email)
    setCookie(null, "email", response.email, {
      maxAge,
      path: "/",
    });

  setCookie(null, "user", "1", {
    maxAge,
    path: "/",
  });
  if (response.token) {
    const jwt: any = jwt_decode(response.token);
    let l: IUser = {
      email: jwt.email,
    };
    return l;
  } else {
    let l: IUser = {
      email: response.email,
    };
    return l;
  }
};

const getJwtUser = (): IUser => {
  const cookies = parseCookies();
  let jwt = cookies.jwt;
  if (jwt) {
    const jwtDecode: any = jwt_decode(jwt);
    let l: IUser = {
      email: jwtDecode.email,
    };

    LogRocket.identify(jwtDecode.email, {
      name: `USER`,
      email: jwtDecode.email,
      role: "USER",
    });

    return l;
  } else {
    let l: IUser = {
      email: cookies.email,
    };
    return l;
  }
};

const JWT = {
  setJwt,
  getJwtUser,
};

export default JWT;
